import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ShieldAlert, ShieldCheck } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { CustodyChain } from "@/components/tx/CustodyChain";
import { CATEGORY_MAP } from "@/lib/data";
import { API, num } from "@/lib/api";
import { fmtDate } from "@/lib/ops";

export default function Verify() {
  const { code } = useParams();
  const [d, setD] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    axios.get(`${API}/verify/${code}`).then((r) => setD(r.data)).catch(() => setError(true));
  }, [code]);

  if (error) return <main className="max-w-3xl mx-auto px-5 py-24 text-center" data-testid="verify-not-found"><ShieldAlert className="w-10 h-10 mx-auto text-red-500 mb-3" />No existe un certificado emitido con el código {code}.</main>;
  if (!d) return <main className="max-w-4xl mx-auto px-5 py-12"><Skeleton className="h-96 rounded-3xl" /></main>;
  const rows = [
    ["Material", `${d.lot.material_tag} · ${CATEGORY_MAP[d.lot.category]?.name || d.lot.category}`],
    ["Código LER", d.lot.ler_code ? `${d.lot.ler_code} · ${d.lot.ler_label}` : "—"],
    ["Toneladas valorizadas", `${num(d.metrics.tons, 3)} t`],
    ["Tratamiento", d.treatment],
    ["Generador", `${d.seller.razon_social} · RUT ${d.seller.rut || "—"}`],
    ["Destinatario", `${d.buyer.razon_social} · RUT ${d.buyer.rut || "—"} · RETC ${d.buyer.retc_id || "—"}`],
    ["Retiro en origen", fmtDate(d.pickup_at)],
    ["Recepción en destino", fmtDate(d.received_at)],
    ["CO₂ eq. mitigado", `${num(d.metrics.co2_t, 3)} t`],
    ["Válido Ley REP", d.rep_valid ? "Sí (gestor con declaración vigente)" : "No (receptor sin declaración vigente)"],
  ];
  return (
    <main className="max-w-4xl mx-auto px-5 lg:px-8 py-12 space-y-6" data-testid="verify-page">
      <div className={`rounded-3xl p-6 sm:p-8 flex items-center gap-4 ${d.integrity ? "bg-[#0a1f18] text-white" : "bg-red-50 text-red-800"}`}>
        {d.integrity ? <ShieldCheck className="w-12 h-12 text-[#00f2a1] shrink-0" /> : <ShieldAlert className="w-12 h-12 shrink-0" />}
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] opacity-70">Certificado {d.code}</p>
          <h1 className="text-2xl sm:text-3xl font-bold" data-testid="verify-status">{d.integrity ? "Certificado auténtico y cadena íntegra" : "La cadena de custodia fue alterada"}</h1>
          <p className="font-mono text-[11px] opacity-60 break-all mt-1">hash {d.hash}</p>
        </div>
      </div>
      <dl className="bg-white border border-slate-200 rounded-3xl divide-y divide-slate-100" data-testid="verify-details">
        {rows.map(([k, v]) => <div key={k} className="flex flex-col sm:flex-row sm:justify-between gap-1 p-4 text-sm"><dt className="text-slate-500">{k}</dt><dd className="font-medium text-[#05130e] sm:text-right">{v}</dd></div>)}
      </dl>
      <CustodyChain events={d.events} integrity={d.integrity} />
    </main>
  );
}
